export default __webpack_public_path__ + "static/media/NDL_40.356eb17c.png";